import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const CloudQuestionIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M14.5 18.3292H6.657C4.085 18.3252 2 16.3182 2 13.8422C2 11.3672 4.085 9.3602 6.657 9.3602C7.05 7.5982 8.451 6.1602 10.332 5.5872C12.212 5.0152 14.288 5.3942 15.776 6.5872C17.264 7.7772 17.938 9.5942 17.546 11.3562H18.536M19 22.3252V22.3352M19 19.3252C19.4483 19.3238 19.8832 19.172 20.235 18.8942C20.5868 18.6163 20.8352 18.2285 20.9406 17.7927C21.0459 17.357 21.0019 16.8985 20.8158 16.4907C20.6297 16.0828 20.3122 15.7492 19.914 15.5432C19.5162 15.3394 19.0611 15.2762 18.6228 15.3639C18.1845 15.4516 17.7888 15.685 17.5 16.0262"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(CloudQuestionIcon);
